import Vue from "vue";
import * as pa from "../api/primeiroAcesso";

const initialState = {
  term: "<p>Carregando...</p>",
  hash: "",
  vinculos: [{ label: "Saúde - Associado", value: 1 }],
  vinculoAdicionado: false,
  autenticado: false,
  autorizador: "",
  cadastrarBiometria: false,
  cadastrarEmail: false,
  emails: [],
  nomeIdentificacao: ""
};

const getServiceErrorMessage = result => {
  if (result?.Data) return "";
  if (result instanceof Error) return result.message;
  return "Serviço temporariamente indisponível";
};

// vuex module
export default {
  namespaced: true,
  state: () => ({ ...initialState }),
  actions: {
    async accpetTerms(context) {
      const ret = await pa.AceitarTermo({ hash: context.state.hash });
      return ret?.Data;
    },
    async fetchTerms(context, { device }) {
      const terms = await pa.TermoAceiteAtual({ device });

      await context.commit("SET_TERM", terms.Data.Termo);
      await context.commit("SET_HASH", terms.Data.Hash);
    },
    async fetchVinculos(context, { cod }) {
      const vincs = await pa.ValidarIdentificacao({
        hash: context.state.hash,
        codigo: cod
      });
      if (vincs?.Data) {
        context.commit("SET_VALUES", vincs.Data);
        return "";
      } else {
        context.commit("CLEAR_VALUES");
        return vincs && vincs instanceof Error ? vincs.message : "Serviço temporariamente indisponível";
      }
    },
    async addEmail(context, { email }) {
      const ret = await pa.CadastrarEmail({
        hash: context.state.hash,
        email
      });
      if (ret.Data) {
        context.commit("SET_VALUES", ret.Data);
      }
      return getServiceErrorMessage(ret);
    },
    async checkCode(context, { codigo }) {
      const ret = await pa.InformarConfirmacao({ hash: context.state.hash, codigo });
      return getServiceErrorMessage(ret);
    },
    async createUser(context, { senha }) {
      const ret = await pa.CadastrarUsuarioOmint({ hash: context.state.hash, senha });
      return getServiceErrorMessage(ret);
    },
    async sendCode(context, { email }) {
      const ret = await pa.EnviarConfirmacao({
        hash: context.state.hash,
        email
      });
      return getServiceErrorMessage(ret);
    },
    async authFace(context, { selfie }) {
      const response = await pa.AutenticarBiometria({
        hash: context.state.hash,
        selfie
      });
      if (response instanceof Error) throw new Error(response.message ?? "Não foi possível realizar a autenticação");

      if (response.Data?.Autorizado) context.commit("SET_VALUES", response.Data.Servico);
      context.commit("SET_AUTENTICADO", response.Data?.Autorizado ?? false);

      return response.Data;
    },
    async saveFace(context, { selfie }) {
      const response = await pa.CadastrarBiometria({
        hash: context.state.hash,
        selfie
      });
      if (response instanceof Error)
        throw new Error(response.message ?? "Não foi possível realizar o cadastro da biometria");
      return response.Data;
    },
    async fetchFaceStatus(context, _) {
      const response = await pa.VerificarCadastroBiometria({
        hash: context.state.hash
      });
      if (response instanceof Error)
        throw new Error(response.message ?? "Não foi possível verificar a situação do cadastro");

      if (response.Data?.Aceito) context.commit("SET_VALUES", response.Data.Servico);
      context.commit("SET_AUTENTICADO", response.Data?.Aceito ?? false);

      return response.Data;
    },
    async registerError(context, { cod, dsc }) {
      const response = await pa.RegistrarErroBiometria({
        hash: context.state.hash,
        codigo: cod,
        descricao: dsc
      });
      return response?.Data ?? {};
    }
  },
  mutations: {
    LOGOUT_USER: state => Object.keys(state).forEach(p => Vue.set(state, p, initialState[p])),
    RESET_CONTEXT: state => Object.keys(state).forEach(p => Vue.set(state, p, initialState[p])),
    CLEAR_VALUES: state => {
      Vue.set(state, "vinculoAdicionado", false);
      Vue.set(state, "cadastrarBiometria", false);
      Vue.set(state, "cadastrarEmail", false);
      Vue.set(state, "emails", []);
      Vue.set(state, "autenticado", false);
      Vue.set(state, "autorizador", "");
      Vue.set(state, "nomeIdentificacao", "");
    },
    SET_VALUES: (state, nextValue) => {
      Vue.set(state, "vinculoAdicionado", nextValue?.ApenasAdicionarVinculo ?? false);
      Vue.set(state, "cadastrarBiometria", nextValue?.CadastrarBiometria ?? false);
      Vue.set(state, "cadastrarEmail", nextValue?.CadastrarEmail ?? false);
      Vue.set(state, "emails", nextValue?.EmailsOfuscados ?? nextValue?.Emails ?? []);
      Vue.set(state, "autenticado", false);
      Vue.set(state, "autorizador", nextValue?.Autorizador ?? "");
      Vue.set(state, "nomeIdentificacao", nextValue?.NomeIdentificacao ?? "");
    },
    SET_AUTENTICADO: (state, nextValue) => {
      Vue.set(state, "autenticado", nextValue);
    },
    SET_TERM: (state, nextTerm) => {
      Vue.set(state, "term", nextTerm);
    },
    SET_HASH: (state, nextTerm) => {
      Vue.set(state, "hash", nextTerm);
    }
  }
};
